import React from 'react';
import { motion } from 'framer-motion';
import GitHubActivity from '../widgets/GitHubActivity';
import NowPlaying from '../widgets/NowPlaying';
import CoffeeTracker from '../widgets/CoffeeTracker';
import CommitStreak from '../widgets/CommitStreak';
import BlogPosts from '../widgets/BlogPosts';
import CodeStatistics from '../widgets/CodeStatistics';
import CurrentLocation from '../widgets/CurrentLocation';

const cellVariants = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] } },
};

const Cell = ({ children, className = '' }) => (
  <motion.div variants={cellVariants} className={className}>
    {children}
  </motion.div>
);

const Widgets = () => {
  return (
    <section id="widgets" className="section-container">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 max-w-3xl">
          <p className="text-[0.7rem] uppercase tracking-[0.4em] text-coffee-300 mb-5">Dashboard</p>
          <h2 className="text-5xl md:text-7xl font-bold mb-6 gradient-text leading-[1.05]">
            Live data.
          </h2>
          <p className="text-lg md:text-xl text-cream-200/80 leading-relaxed">
            Real-time insights into my development workflow.
          </p>
        </div>

        {/* Widgets Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-40px' }}
          variants={{ show: { transition: { staggerChildren: 0.04 } } }}
        >
          {/* Row 1: Spotify and Coffee */}
          <Cell><NowPlaying /></Cell>
          <Cell><CoffeeTracker /></Cell>

          {/* Row 1-2: GitHub (tall, spans 2 rows) */}
          <Cell className="lg:row-span-2"><GitHubActivity /></Cell>

          {/* Row 2: Streak + Location */}
          <Cell><CommitStreak /></Cell>
          <Cell><CurrentLocation /></Cell>

          {/* Row 3: Blog + Stats */}
          <Cell className="md:col-span-2 lg:col-span-2"><BlogPosts /></Cell>
          <Cell className="md:col-span-2 lg:col-span-1"><CodeStatistics /></Cell>
        </motion.div>
      </div>
    </section>
  );
};

export default Widgets;
